import Cookies from 'js-cookie';

const COOKIE_EXPIRY = 1_800_000;

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const checkCookieExists = (name: string) => {
  return Cookies.get(name) !== undefined;
};

export const writeCookie = (name: string, value: string, expiration?: Date, path?: string, domain?: string) => {
  Cookies.set(name, value, { expires: expiration, path: path, domain: domain });
};

export const getDomain = (url: string) => {
  if (!url) return;

  const urlObj = new URL(url);

  try {
    return urlObj.hostname.match(/[^.]*(?:\.[^.]{2,3}){1,2}$/i)![0];
  } catch {}
};

export const getCookieAsObj = (cookieName: any) => {
  const cookie = getCookie(cookieName)?.split('|') ?? undefined;

  // If cookie doesn't exist, return null
  if (cookie === undefined) {
    return undefined;
  }

  const cookieAsObj = {} as any;

  cookie.forEach((element) => {
    const cookieKeyValuePair = element.split('=');
    cookieAsObj[cookieKeyValuePair[0]] = cookieKeyValuePair[1];
  });

  return cookieAsObj;
};

export const newCookieExpirationDate = () => {
  return new Date(Date.now() + COOKIE_EXPIRY);
};
